import { useAuthApiClient } from "@inbody/keycloak";
import { useQuery } from "@tanstack/react-query";
const PROFILE_IMAGE_ENDPOINT = "File/SasToken/ms-profile";
const SAS_STALE_TIME = 1e3 * 60 * 4;
const useProfileImage = (email) => {
  var _a;
  const apiClient = useAuthApiClient();
  const query = useQuery({
    queryKey: ["user-search", "profile-image", email],
    queryFn: () => apiClient.get(`${PROFILE_IMAGE_ENDPOINT}/${email}`),
    enabled: !!email,
    staleTime: SAS_STALE_TIME,
    retry: false
  });
  return { imageUrl: ((_a = query.data) == null ? void 0 : _a.data) ?? "" };
};
export {
  useProfileImage
};
